import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

import cel from "../assets/section2/celebrationImg.png";
import img2 from "../assets/section2/nutritionImg.png";
import img4 from "../assets/section2/packageImg.png";

import "../styles/HomePageStyles/heroSectionsStyle.css";
import subimg1 from "../assets/section2/sec1.png";
import subimg2 from "../assets/section2/sec2.png";
import subimg3 from "../assets/section2/sec3.png";

import OrderBtn from "../utils/OrderBtn";
import config from "../config";

const Section2 = ({
  taste_title,
  taste_description,
  service_box1_image,
  service_box1_title,
  service_box1_description,
  service_box2_image,
  service_box2_title,
  service_box2_description,
  service_box3_image,
  service_box3_title,
  service_box3_description,
  right_side_image1,
  right_side_image2,
  right_side_image3,
  right_side_video_link,
}) => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  // console.log("taste_description", taste_description);

  return (
    <div className="section2_wrapper">
      {/* <div className="sec2_bg1"></div> */}

      <div className="section2_container">
        <div className="left_section">
          <div className="left_section_wrapper">
            <div className="left_Sec_heading">
              {taste_title && taste_title !== "-" ? (
                <h2 data-aos="zoom-out">{taste_title}</h2>
              ) : (
                <h2 data-aos="zoom-out">Taste the Magic of Rollz Ice Cream!</h2>
              )}
              {taste_description && taste_description !== "-" ? (
                <p data-aos="zoom-out">{taste_description}</p>
              ) : (
                <p data-aos="zoom-out">
                  Indulge in a one-of-a-kind ice cream experience that’s as fun
                  as it is delicious. Our handcrafted rolls are made with the
                  freshest ingredients and bursting with bold flavors. Whether
                  you’re craving something classic or adventurous, we have the
                  perfect roll just for you. Come taste the magic today and
                  discover why Rollz is your next sweet obsession!
                </p>
              )}
            </div>

            <div className="left_services">
              <div className="services">
                <div className="service_img" data-aos="zoom-out">
                  <img
                    src={
                      service_box1_image && service_box1_image !== "-"
                        ? service_box1_image
                        : cel
                    }
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="service_heading" data-aos="zoom-out">
                  {service_box1_title && service_box1_title !== "-" ? (
                    <h5>{service_box1_title}</h5>
                  ) : (
                    <h5>Celebration in Every Roll</h5>
                  )}
                </div>
                <div className="service_disc" data-aos="zoom-out">
                  {service_box1_description &&
                  service_box1_description !== "-" ? (
                    <p>{service_box1_description}</p>
                  ) : (
                    <p>
                      Every scoop brings joy, from classic to creative flavors
                    </p>
                  )}
                </div>
              </div>

              <div className="services">
                <div className="service_img" data-aos="zoom-out">
                  <img
                    src={
                      service_box2_image && service_box2_image !== "-"
                        ? service_box2_image
                        : img2
                    }
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="service_heading" data-aos="zoom-out">
                  {service_box2_title && service_box2_title !== "-" ? (
                    <h5>{service_box2_title}</h5>
                  ) : (
                    <h5>Nutrition Rich, Flavor Packed</h5>
                  )}
                </div>
                <div className="service_disc" data-aos="zoom-out">
                  {service_box2_description &&
                  service_box2_description !== "-" ? (
                    <p>{service_box2_description}</p>
                  ) : (
                    <p>
                      Indulge in rich, flavorful ice cream made with quality
                      ingredients.
                    </p>
                  )}
                </div>
              </div>

              <div className="services">
                <div className="service_img" data-aos="zoom-out">
                  <img
                    src={
                      service_box3_image && service_box3_image !== "-"
                        ? service_box3_image
                        : img4
                    }
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="service_heading" data-aos="zoom-out">
                  {service_box3_title && service_box3_title !== "-" ? (
                    <h5>{service_box3_title}</h5>
                  ) : (
                    <h5>Secure Packing, Sweet Delivery</h5>
                  )}
                </div>
                <div className="service_disc" data-aos="zoom-out">
                  {service_box3_description &&
                  service_box3_description !== "-" ? (
                    <p>{service_box3_description}</p>
                  ) : (
                    <p>
                      Fresh, delicious ice cream delivered safely to your door.
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="left-btn" data-aos="zoom-out">
              {/* <button className="order-online">
                <div className="order-online-trans-1"></div>
                <div  className="order-online-trans-2"></div>
                 Visit Our Nearest Location
              </button> */}
              <OrderBtn text={"Visit Our Nearest Location"} url={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}`} />
            </div>
          </div>
        </div>

        <div className="right_section" data-aos="zoom-out">
          <div className="right_section_wrapper">
            <div className="col-6 rigth_image1">
              <div className="subImg1">
                <img
                  // src={
                  //   (right_side_image1 && right_side_image1 !== "-") || subimg1
                  // }
                  src={
                    right_side_image1 && right_side_image1 !== "-"
                      ? right_side_image1
                      : subimg1
                  }
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="subImg2">
                <img
                  src={
                    right_side_image2 && right_side_image2 !== "-"
                      ? right_side_image2
                      : subimg2
                  }
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-6 rigth_image2">
              <div className="subImg3">
                <img
                  src={
                    right_side_image3 && right_side_image3 !== "-"
                      ? right_side_image3
                      : subimg3
                  }
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="circular-container">
        <div className="svg-wrapper">
          <svg viewBox="0 0 200 200" className="circular-svg">
            <path
              id="circlePath"
              d="M 100, 100
           m -75, 0
           a 75,75 0 1,1 150,0
           a 75,75 0 1,1 -150,0"
            />
            <text>
              <textPath href="#circlePath" startOffset="50%">
                {" "}
                Our Rollz Tour * Our Rollz Tour * Our Rollz Tour *
              </textPath>
            </text>
          </svg>
          <Link
            to={
              right_side_video_link && right_side_video_link !== "-"
                ? right_side_video_link
                : "https://youtu.be/qgKhSv1nJGU?feature=shared"
            }
            target="_blank"
            className="play-icon"
          >
            <div className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--font-color2)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
            </div>
          </Link>
        </div>
      </div>

      <div className="sec2_bg2"></div>
    </div>
  );
};

export default Section2;
